import React from "react";
import {Button, Col, Form, FormGroup, Input, Row} from "reactstrap";
import Reset from "../containers/Reset";

const formatResult = points => points + (points === 1 ? " точка" : " точки");

const formatRow = (points, min, max, className) => {
    if (points >= min && points <= max) {
        return className;
    }

    return "";
};

const validateEmail = str => {
    // eslint-disable-next-line
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str);
};

const isStringLengthInRange = (str, min, max) => {
    if (str === undefined || str === null) {
        return false;
    }

    return !(str.length < min || str.length > max);

};

const ResultsView = ({points = 0, session = {}, request = {}, updateSession = f => f, submitResults = f => f}) => (
    <div className={"test-results"}>
        <Row className={"mt-1"}>
            <Col md={{size: 6, offset: 0, order: 1}} xs={{size: 12, order: 1}}>
                <h4>Вашият резултат: {formatResult(points)}</h4>
                <table className={"table table-dark"}>
                    <thead>
                    <tr>
                        <th scope="col">Общ резултат</th>
                        <th scope="col">Ниво на депресия</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className={formatRow(points, 0, 5, "bg-success")}>
                        <th>0 - 5 т</th>
                        <th>Няма депресия</th>
                    </tr>
                    <tr className={formatRow(points, 6, 10, "bg-success")}>
                        <th>6 - 10 т</th>
                        <th>Нормално състояние на тъга</th>
                    </tr>
                    <tr className={formatRow(points, 11, 25, "bg-info")}>
                        <th>11 - 25 т</th>
                        <th>Лека депресия</th>
                    </tr>
                    <tr className={formatRow(points, 26, 50, "bg-warning")}>
                        <th>26 - 50 т</th>
                        <th>Умерена депресия</th>
                    </tr>
                    <tr className={formatRow(points, 51, 75, "bg-danger")}>
                        <th>51 - 75 т</th>
                        <th>Тежка депресия</th>
                    </tr>
                    <tr className={formatRow(points, 76, 100, "bg-danger")}>
                        <th>76 - 100 т</th>
                        <th>Изключително тежка депресия</th>
                    </tr>
                    </tbody>
                </table>
            </Col>
            <Col md={{size: "auto", order:2}} xs={{size: 12, order: 3}} className={"mb-5"}>
                <h4>Свържете се с мен</h4>
                <Form>
                    <FormGroup>
                        <Input id={"username"}
                               type={"text"}
                               placeholder={"Вашите имена"}
                               className={"bg-dark text-white"}
                               value={session.username}
                               onChange={e => updateSession({username: e.target.value.substr(0, 40)})}
                               valid={isStringLengthInRange(session.username, 3, 40)}
                               invalid={!isStringLengthInRange(session.username, 3, 40)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Input id={"email"}
                               type={"text"}
                               placeholder={"Имейл адрес"}
                               className={"bg-dark text-white"}
                               value={session.email}
                               onChange={e => updateSession({email: e.target.value.substr(0, 100)})}
                               valid={validateEmail(session.email)}
                               invalid={!validateEmail(session.email)}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Input id={"phone"}
                               type={"text"}
                               placeholder={"Телефон"}
                               className={"bg-dark text-white"}
                               value={session.phone}
                               onChange={e => updateSession({phone: e.target.value.substr(0, 20)})}
                               valid={isStringLengthInRange(session.phone, 8, 20)}
                               invalid={!isStringLengthInRange(session.phone, 8, 20)}/>
                    </FormGroup>
                    <FormGroup>
                        <Input id={"message"}
                               type={"textarea"}
                               placeholder={"Съобщение"}
                               className={"bg-dark text-white"}
                               value={session.message}
                               onChange={e => updateSession({message: e.target.value.substr(0, 300)})}
                               valid={isStringLengthInRange(session.message, 2, 300)}
                        />
                    </FormGroup>
                    <Reset linkText={"Започни отначало"}/>
                    <Button className={"float-right ml-1 btn btn-success"} onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!validateEmail(session.email) ||
                            !isStringLengthInRange(session.phone, 8, 20) ||
                            !isStringLengthInRange(session.username, 3, 40) ||
                            !isStringLengthInRange(session.message, 0, 300)) {
                            alert("Моля попълнете формата за контакт. Съобщението не е задължително.")
                            return;
                        }

                        submitResults(request);
                    }}>Изпрати</Button>
                </Form>
                <div className={"mt-2 text-center"}>
                    <a href={"../depresia"} title={"Информация за депресията"}>Научете повече за депресията</a>
                </div>
            </Col>
            <Col md={{size: "auto", order: 3}} xs={{size: 12, order: 2}} className={"mb-3"}>
                <small>Ако попадате в последните 3 графи може би имате нужда от професионална намеса, която ще облекчи състоянието Ви на дискомфорт. Не се колебайте да потърсите специалист.</small>
            </Col>
        </Row>
        <Row>

        </Row>
    </div>
);

export default ResultsView;